(function () {
  var KEY = 'pf_quote';
  var KIND_LABEL = { quote: 'Quote', sample: 'Sample', bulk: 'Bulk request' };

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* private mode */ }
    render();
  }
  function add(item) {
    var items = read();
    for (var i = 0; i < items.length; i++) {
      if (items[i].sku === item.sku && items[i].kind === item.kind && items[i].title === item.title
          && (items[i].donors || '') === (item.donors || '')) {
        items[i].qty += item.qty;
        write(items);
        return;
      }
    }
    items.push(item);
    write(items);
  }
  function count() {
    return read().reduce(function (s, it) { return s + (it.qty || 1); }, 0);
  }

  /* header badge + quote page table */
  function render() {
    var n = count();
    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
      el.hidden = n === 0;
    });
    // My Quote links: the inquiry form while empty, the basket page once lines exist. URLs come from
    // window.theme (Liquid settings), never from DOM attributes (CodeQL js/xss-through-dom).
    var urls = window.theme || {};
    if (urls.quoteBasketUrl) {
      document.querySelectorAll('[data-quote-basket]').forEach(function (a) {
        a.href = n > 0 ? urls.quoteBasketUrl : (urls.quoteFormUrl || urls.quoteBasketUrl);
      });
    }
    var table = document.querySelector('[data-quote-table]');
    if (table) renderTable(table);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderTable(table) {
    var items = read();
    var body = table.querySelector('tbody');
    var empty = document.querySelector('[data-quote-empty]');
    var form = document.querySelector('[data-quote-form]');
    if (empty) empty.hidden = items.length > 0;
    if (form) form.hidden = items.length === 0;
    table.hidden = items.length === 0;
    body.innerHTML = items.map(function (it, i) {
      return '<tr>' +
        '<td class="quote__product"><a href="' + esc(it.url || '#') + '">' + esc(it.title) + '</a>' +
          (it.size ? '<p class="quote__meta">' + esc(it.size) + '</p>' : '') +
          (it.donors ? '<p class="quote__meta">Individual donors: ' + esc(it.donors) + '</p>' : '') + '</td>' +
        '<td class="quote__sku">' + esc(it.sku) + '</td>' +
        '<td class="quote__kind">' + esc(KIND_LABEL[it.kind] || 'Quote') + '</td>' +
        '<td class="quote__qty"><input type="number" min="1" value="' + (it.qty || 1) + '" data-quote-qty="' + i + '" aria-label="Quantity"></td>' +
        '<td class="quote__remove"><button type="button" class="link" data-quote-remove="' + i + '">Remove</button></td>' +
      '</tr>';
    }).join('');
    var hidden = document.querySelector('[data-quote-items]');
    if (hidden) hidden.value = serialize(items);
    var app = document.querySelector('[data-quote-app]');
    if (app) fillApp(app, items);
  }

  /* Shopify Forms block on the quote page: fill its "Quote items" field (forms_spec.json) from the
     basket and empty the basket once the shopper submits a valid form. */
  var appRoot;
  function fillApp(app, items) {
    if (!window.pfFormsApp) return;
    function apply(root) {
      appRoot = root;
      var el = window.pfFormsApp.control(root, 'Quote items');
      if (el) window.pfFormsApp.fill(el, serialize(items));
      var f = root.querySelector('form');
      if (f && !f.dataset.pfQuoteBound) {
        f.dataset.pfQuoteBound = '1';
        // ponytail: the app owns validation; a rejected submit that passed checkValidity loses the basket.
        // Persist the empty basket WITHOUT re-rendering: render() would hide the wrapper (no items)
        // and take the app's thank-you message with it (smoke 2026-09-18).
        f.addEventListener('submit', function () {
          if (!f.checkValidity()) return;
          try { localStorage.setItem(KEY, '[]'); } catch (e) { /* private mode */ }
          document.querySelectorAll('[data-quote-count]').forEach(function (el) { el.hidden = true; });
        });
      }
    }
    if (appRoot && app.contains(appRoot.host)) apply(appRoot); else window.pfFormsApp.ready(app, apply);
  }

  function serialize(items) {
    return items.map(function (it) {
      return (KIND_LABEL[it.kind] || 'Quote') + ' | ' + it.title + (it.size ? ' - ' + it.size : '') +
        ' | SKU ' + (it.sku || '-') + ' | Qty ' + (it.qty || 1) +
        (it.donors ? ' | Individual donors ' + it.donors : '') +
        (it.url ? ' | ' + location.origin + it.url : '');
    }).join('\n');
  }

  function toast(msg) {
    var el = document.getElementById('pf-quote-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pf-quote-toast';
      el.className = 'quote-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    var basket = (window.theme || {}).quoteBasketUrl;
    el.textContent = msg;
    if (basket) {
      var a = document.createElement('a');
      a.href = basket;
      a.textContent = 'View quote';
      el.appendChild(document.createTextNode(' '));
      el.appendChild(a);
    }
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 4000);
  }

  /* an Add to Quote link -> a basket line. Bulk request (?bulk=1) and Request Sample (?sample=1) are
     left to navigate to their own Forms-app pages (/pages/bulk-request, /pages/sample-reserve-order);
     a bulk link with no bulk page (bulk_url blank) still lands here as a basket line. */
  function itemFromLink(a) {
    var p = new URL(a.href, location.origin).searchParams;
    var form = a.closest('form');
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var donorsEl = form && form.querySelector('[data-donor-count]');
    var sel = form && form.querySelector('[data-variant-select]');
    var card = a.closest('.product-card');
    var cardLink = card && card.querySelector('a[href*="/products/"]');
    var donors = donorsEl ? String(Math.max(1, parseInt(donorsEl.value, 10) || 1)) : '';
    return {
      title: p.get('product') || document.title,
      sku: p.get('sku') || '',
      size: sel && sel.selectedIndex > 0 ? sel.options[sel.selectedIndex].text : '',
      qty: qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1,
      donors: donors,
      kind: p.get('sample') === '1' ? 'sample' : p.get('bulk') === '1' ? 'bulk' : 'quote',
      url: cardLink ? cardLink.getAttribute('href') : location.pathname
    };
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-quote-link], .product-card__quote');
    var href = a && (a.getAttribute('href') || '');
    if (a && href.indexOf('product=') !== -1) {
      // Only the quote basket page (settings.quote_url) collects lines. Any other prefilled ?product=
      // link (/pages/custom-kit, /pages/bulk-request, ...) is a lead form: navigate, never add.
      var basket = (window.theme || {}).quoteBasketUrl || '';
      if (basket && href.split('?')[0] !== basket) return;
      if (href.indexOf('sample=1') !== -1) return;  // Sample / Reserve Order page
      if (href.indexOf('bulk=1') !== -1 && href.indexOf('/pages/bulk-request') !== -1) return;  // Bulk Request page
      if (href.indexOf('fresh=1') !== -1) return;  // fresh tissue collection request: always a form, never a basket line
      e.preventDefault();
      var item = itemFromLink(a);
      add(item);
      toast((item.kind === 'sample' ? 'Sample request added' : 'Added to your quote') + ': ' + item.title);
      return;
    }
    var cartLink = e.target.closest('[data-quote-from-cart]');
    if (cartLink) {
      e.preventDefault();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        (cart.items || []).forEach(function (li) {
          add({ title: li.product_title, sku: li.sku || '', size: li.variant_title || '', qty: li.quantity,
                donors: (li.properties && li.properties['Individual donors']) || '',
                kind: 'quote', url: li.url });
        });
        location.href = cartLink.getAttribute('href');
      }).catch(function () { location.href = cartLink.getAttribute('href'); });
      return;
    }
    var rm = e.target.closest('[data-quote-remove]');
    if (rm) {
      var items = read();
      items.splice(parseInt(rm.getAttribute('data-quote-remove'), 10), 1);
      write(items);
    }
  });

  document.addEventListener('change', function (e) {
    var q = e.target.closest('[data-quote-qty]');
    if (!q) return;
    var items = read();
    var i = parseInt(q.getAttribute('data-quote-qty'), 10);
    if (items[i]) {
      items[i].qty = Math.max(1, parseInt(q.value, 10) || 1);
      var d = parseInt(items[i].donors, 10);
      if (!isNaN(d) && d > items[i].qty) items[i].donors = String(items[i].qty);
      write(items);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quote-form]');
    if (!form) return;
    var items = read();
    if (!items.length) {
      e.preventDefault();
      toast('Your quote is empty -- add a product first.');
      return;
    }
    var hidden = form.querySelector('[data-quote-items]');
    if (hidden) hidden.value = serialize(items);
  });

  function init() {
    if (document.querySelector('[data-quote-posted]')) write([]); // contact form accepted -> basket sent
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.PFQuote = { read: read, write: write, add: add, render: render };
})();
